/**
 * The notifications panel's API handle. list, unread-count, the two mark-read
 * calls and the per-channel delivery preferences all live on the shared,
 * session-aware data layer in {@link module:api/resources}. This module is a
 * thin hook that hands the bell that `notifications` slice, so every call runs
 * through the ONE app client (bearer token + 401-to-/login).
 */
import { useSession } from '../../auth/session';
import type { NotifApi } from '../../api/resources';

export type { NotifApi };

/** The notifications API bound to the live session. */
export function useNotifApi(): NotifApi {
  return useSession().api.notifications;
}
